var exports = {
  "kL": "xdde3148b--4fd250--container",
  "q9": "xdde3148b--4fd250--price",
  "o1": "xdde3148b--4fd250--actions",
};

module.exports = exports;
